<i18n locale="en" lang="json">
{
  "search": "Search"
}
</i18n>
<i18n locale="nl" lang="json">
{
  "search": "Zoek"
}
</i18n>

<template>
  <text-field
    v-model="internalValue"
    v-bind="
      mergeProps($props, {
        modelValue: internalValue,
        label: props.label || t('search'),
        hideDetails: true,
        variant: 'underlined',
        debounce: 0,
      })
    "
    :test-id="['SearchField', getModelExpression()]"
  >
    <template #append-inner>
      <slot name="append-inner">
        <button
          v-if="internalValue"
          class="mr-2"
          @click="internalValue = undefined"
        >
          <font-awesome-icon :icon="faTimesCircle" />
        </button>
        <button @click="emit('click:search-icon')">
          <font-awesome-icon :icon="faSearch" />
        </button>
      </slot>
    </template>
  </text-field>
</template>

<script lang="ts" setup>
import { faSearch, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { mergeProps } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  actionableComponentProps,
  getModelExpression,
} from '@/common/components/ActionableComponent';
import type { FormFieldEmits } from '@/common/components/form/FormField.vue';
import { useValue } from '@/common/components/form/FormField.vue';
import { TextField } from '@/common/components/form';

const props = defineProps({
  ...actionableComponentProps,
  ...TextField.prop,
  label: String,
  modelValue: String,
  debounce: { type: Number, default: 400 },
});
const emit = defineEmits<
  FormFieldEmits<string> & { (e: 'click:search-icon'): void }
>();

const { t } = useI18n();
const internalValue = useValue<string | undefined>(props, emit);
</script>
